import { render, staticRenderFns } from "./ContentEditorUploader.vue?vue&type=template&id=65b438e4&scoped=true&"
import script from "./ContentEditorUploader.vue?vue&type=script&lang=ts&"
export * from "./ContentEditorUploader.vue?vue&type=script&lang=ts&"
import style0 from "./ContentEditorUploader.vue?vue&type=style&index=0&id=65b438e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b438e4",
  null
  
)

export default component.exports
import QFile from 'quasar/src/components/file/QFile.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QFile,QIcon,QCircularProgress,QSpinnerDots,QField});
